export default __webpack_public_path__ + "static/media/wave-mobile.37f4a254.svg";